import { render, staticRenderFns } from "./MergeModal.vue?vue&type=template&id=00d1dc33&"
import script from "./MergeModal.vue?vue&type=script&lang=js&"
export * from "./MergeModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports